import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const DialogConfirmation = ({ confirmInfo, content, handleCloseDialog }) => {
  const handleClose = () => {
    handleCloseDialog(false);
  };

  const handleDeleteRequestType = () => {
    handleCloseDialog(true, confirmInfo.data);
  };

  return (
    <Dialog
      open={confirmInfo.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{confirmInfo.title}</DialogTitle>
      {content
        && <DialogContent>
          {content}
        </DialogContent>
      }
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          {confirmInfo.cancel ? confirmInfo.cancel : "Cancelar"}
        </Button>
        <Button onClick={handleDeleteRequestType} color="primary">
          {confirmInfo.confirm ? confirmInfo.confirm : "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmation;
